import styled from 'styled-components';
import { Heading, HEADING_SIZE, Slideout, Text } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const StyledSlideout = styled(Slideout)`
    .dr-slideout-content-container {
        /* Percentages, not vw: the panel is position: fixed with right: 0, and vw includes
           the vertical scrollbar while right: 0 anchors inside it. With a space-taking
           scrollbar, 100vw overhangs the left edge and clips content. */
        width: 64.5%;

        @media (max-width: ${BreakPoints.TABLET}) {
            width: 93%;
        }

        @media (max-width: ${BreakPoints.PHONE}) {
            width: 100%;
        }
    }
    .dr-slideout-heading {
        h3 {
            font-weight: 700;
        }
    }
    .dr-slideout-content {
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
`;

export const SlideoutContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex: 1 1 0;
    gap: 16px;
`;

export const StyledSelectInfo = styled(Text)`
    color: ${({ theme }) => theme.uiBricks.packageCardBorderColor || '#000'};
`;

export const CustomerVehiclesContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    height: 100%;
    overflow: auto;
    gap: 16px;

    /* Slimmer scrollbar (Firefox + WebKit): default classic scrollbars on Windows render
       much wider than macOS overlay scrollbars, making the deal list look inconsistent
       across platforms. */
    scrollbar-width: thin;
    &::-webkit-scrollbar {
        width: 6px;
    }
`;

export const TradeInBadges = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 7px;
    border-radius: 4px;
    background-color: #f3f3f3;
`;

export const TradeInHeading = styled(Heading)`
    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: ${HEADING_SIZE[7]};
    }
`;

export const TradeInBadgeGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
`;

export const TradeInBadge = styled.span<{ $variant: 'info' | 'light' }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    padding: 4px 10px;
    border-radius: 10px;
    box-sizing: border-box;
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    overflow-wrap: break-word;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
    background-color: ${({ $variant, theme }) =>
        $variant === 'info' ? theme.uiBricks?.primaryButtonDisabledBackgroundColor : theme.uiBricks?.modalWrapperBorderColor};
    color: ${({ theme }) => theme.uiBricks?.primaryButtonHoverColor};
`;

export const VehicleNameWithTags = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`;

export const FooterContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    height: 56px;
    padding: 8px 16px;
    background-color: rgba(244, 244, 244, 0.96);
    border-top: ${({ theme }) => `1px solid ${theme.uiBricks.defaultInputFieldDisabledFontColor || '#B2B2B2'}`};
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    z-index: 1;
`;

export const FooterButtonGroup = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;

    .cancel-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        box-sizing: border-box;
        width: 75px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        padding: 12px;
        background-color: transparent;
        border: none;
        border-radius: 4px;
        color: ${({ theme }) => theme.uiBricks?.primaryAccentColor};
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0;

        &:hover {
            background-color: transparent;
        }
    }

    .open-deal-button,
    .compare-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        box-sizing: border-box;
        width: auto;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        padding: 12px;
        background-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor};
        border: none;
        border-radius: 4px;
        color: ${({ theme }) => theme.uiBricks?.pageBackgroundColor};
        font-weight: 600;
        font-style: normal;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0;
        text-transform: none;
        &:disabled {
            background-color: ${({ theme }) => theme.uiBricks?.defaultPencilContainerBoxShadow || '#c4c4c4'};
            border-color: ${({ theme }) => theme.uiBricks?.defaultPencilContainerBoxShadow || '#c4c4c4'};
            color: #6d6d6d;
            cursor: not-allowed;
            opacity: 0.7;
        }
    }
`;
